// Глобальная конфигурация фронта.
// serverUrl — базовый origin API. Пусто = API на том же origin, что и панель (same-origin);
// это прод-дефолт. Переопределяется на СБОРКЕ через REACT_APP_SERVER_URL (.env / .env.local)
// — напр. для локальной разработки против живого бэкенда на другом origin. См. .env.example.
const CONFIG = {
    serverUrl: process.env.REACT_APP_SERVER_URL || '',
    // Гейт прав (меню, роуты, кнопки). ВЫКЛЮЧЕН по умолчанию — все аккаунты равны, зеркало
    // бэкендного config/panel.php permissions_enabled. Включить обратно:
    // REACT_APP_PERMISSIONS_ENABLED=true на сборке (+ CP_PERMISSIONS_ENABLED=true в .env API).
    permissionsEnabled: process.env.REACT_APP_PERMISSIONS_ENABLED === 'true',
};

export default CONFIG;
